import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { Colors } from '@oy/uicore';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Location } from 'react-router-dom';
import { PATH } from 'src/constants/Path';
import { useEnv, useTranslate } from 'src/hooks';
import { RootState } from 'src/redux/reducers/rootReducer';
import { storage } from 'src/utilities/Storage';

export const useMenuItemImpl = () => {
  const [isHover, setIsHover] = useState(false);
  const { isProdEnv } = useEnv();
  const auth = useSelector((state: RootState) => state.auth);
  const { lang } = useTranslate();
  const { user } = auth;
  const isNotificationTooltipOpen = useSelector(
    (state: RootState) => state.notificationAnnouncementPreview.isTooltipOpen,
  );

  const getIconColor = (path: string, location: Location) => {
    const isItemActive = location.pathname.includes(path);
    if (isProdEnv) {
      if (isNotificationTooltipOpen) {
        if (path === PATH.notifications) {
          return 'var(--token-color-brand100)';
        }
        return Colors.WHITE;
      }
      if (isHover || isItemActive) {
        return 'var(--token-color-brand100)';
      }
      return Colors.WHITE;
    }
    return Colors.BLACK100;
  };

  const setOnboardAccStatement = (path: string) => {
    switch (path) {
      case 'transaction-report/account-statement':
        if (
          storage.get(`boolGetStartedCheckout${user?.username}`, false) &&
          storage.get(`boolGetStartedBulk${user?.username}`, false)
        ) {
          storage.set(`boolGetStartedAccStatement${user?.username}`, true);
        }
        break;

      default:
        break;
    }
  };

  const trackMenuItemSelection = (path: string, analyticEvent?: string) => {
    setOnboardAccStatement(path);
    if (analyticEvent) {
      AnalyticsManager.instance().track(AnalyticsEvent.menubar_button, {
        menu_option: analyticEvent,
        language: lang,
      });
    }
  };

  return {
    trackMenuItemSelection,
    setIsHover,
    getIconColor,
    isNotificationTooltipOpen,
  };
};
